const rocketLeagueSteps = {
  totalSteps: 9,
  steps: [
    "ApplyDiscord",
    "ApplyFirstName",
    "ApplyDiscordEmail",
    "ApplyAbout",
    "ApplyCountry",
    "ApplyServers",
    "ApplyPlatform",
    "ApplyRank",
    // "ApplySubmitted",
  ],
  servers: [
    { id: 0, title: "Europe West" },
    { id: 1, title: "Europe Nordic East" },
    { id: 2, title: "North America" },
    { id: 3, title: "Oceania" },
    { id: 4, title: "Latin America North" },
    { id: 5, title: "Latin America South" },
    { id: 6, title: "Brazil" },
    { id: 7, title: "China" },
    { id: 8, title: "Japan" },
    { id: 9, title: "Korea" },
    { id: 10, title: "Other" },
  ],
  ranks: [
    {
      id: 34,
      title: "Grand Champion III",
    },
    {
      id: 35,
      title: "Supoersonic",
    },
  ],
};

const LeagueOfLegendsSteps = {
  totalSteps: 9,
  steps: [
    "ApplyDiscord",
    "ApplyFirstName",
    "ApplyDiscordEmail",
    "ApplyAbout",
    "ApplyCountry",
    "ApplyServers",
    "ApplyRank",
    "ApplyRoles",
    // "ApplySubmitted",
  ],
  servers: [
    { id: 0, title: "Europe West" },
    { id: 1, title: "Europe Nordic East" },
    { id: 2, title: "North America" },
    { id: 3, title: "Oceania" },
    { id: 4, title: "Latin America North" },
    { id: 5, title: "Latin America South" },
    { id: 6, title: "Brazil" },
    { id: 7, title: "Oceania" },
    { id: 8, title: "Russia" },
    { id: 9, title: "Turkey" },
    { id: 10, title: "Japan" },
    { id: 11, title: "Korea" },
    { id: 12, title: "China" },
    { id: 13, title: "Philippines" },
    { id: 14, title: "Singapore" },
    { id: 15, title: "Taiwan" },
    { id: 16, title: "Thailand" },
    { id: 17, title: "Vietnam" },
  ],
  ranks: [
    {
      id: 8,
      title: "Master",
    },
    {
      id: 9,
      title: "Grandmaster",
    },
    {
      id: 10,
      title: "Challenger",
    },
  ],
  roles: [
    {
      id: 1,
      title: "Top",
    },
    {
      id: 2,
      title: "Jungler",
    },
    {
      id: 3,
      title: "Mid",
    },
    {
      id: 4,
      title: "AD Carry",
    },
    {
      id: 5,
      title: "Support",
    },
  ],
};

const apexLegendsStep = {
  totalSteps: 9,
  steps: [
    "ApplyDiscord",
    "ApplyFirstName",
    "ApplyDiscordEmail",
    "ApplyCountry",
    "ApplyServers",
    "ApplyPlatform",
    "ApplyAbout",
    "ApplyRank",
    // "ApplySubmitted",
  ],
  servers: [
    { id: 0, title: "Europe West" },
    { id: 1, title: "Europe Nordic East" },
    { id: 2, title: "North America" },
    { id: 3, title: "Oceania" },
    { id: 4, title: "Latin America North" },
    { id: 5, title: "Latin America South" },
    { id: 6, title: "Brazil" },
    { id: 7, title: "China" },
    { id: 8, title: "Japan" },
    { id: 9, title: "Korea" },
    { id: 10, title: "Other" },
  ],
  ranks: [
    {
      id: 64,
      title: "Master",
    },
    {
      id: 65,
      title: "Predator",
    },
  ],
};
const rainbowSixStep = {
  totalSteps: 9,
  steps: [
    "ApplyDiscord",
    "ApplyFirstName",
    "ApplyDiscordEmail",
    "ApplyCountry",
    "ApplyServers",
    "ApplyPlatform",
    "ApplyAbout",
    "ApplyRank",
    // "ApplySubmitted",
  ],
  servers: [
    { id: 0, title: "Europe West" },
    { id: 1, title: "Europe Nordic East" },
    { id: 2, title: "North America" },
    { id: 3, title: "Oceania" },
    { id: 4, title: "Latin America North" },
    { id: 5, title: "Latin America South" },
    { id: 6, title: "Brazil" },
    { id: 7, title: "China" },
    { id: 8, title: "Japan" },
    { id: 9, title: "Korea" },
    { id: 10, title: "Other" },
  ],
  ranks: [
    {
      id: 26,
      title: "Diamond",
    },
    {
      id: 27,
      title: "Champion",
    },
  ],
};

const overwatch2Step = {
  totalSteps: 10,
  steps: [
    "ApplyDiscord",
    "ApplyFirstName",
    "ApplyDiscordEmail",
    "ApplyCountry",
    "ApplyServers",
    "ApplyRoles",
    "ApplyPlatform",
    "ApplyAbout",
    "ApplyRank",
    // "ApplySubmitted",
  ],
  servers: [
    { id: 0, title: "Europe West" },
    { id: 1, title: "Europe Nordic East" },
    { id: 2, title: "North America" },
    { id: 3, title: "Oceania" },
    { id: 4, title: "Latin America North" },
    { id: 5, title: "Latin America South" },
    { id: 6, title: "Brazil" },
    { id: 7, title: "China" },
    { id: 8, title: "Japan" },
    { id: 9, title: "Korea" },
    { id: 10, title: "Other" },
  ],
  ranks: [
    {
      id: 50,
      title: "Grand Master I",
    },
    {
      id: 500,
      title: "Top 500",
    },
  ],
};
const theFinalsStep = {
  totalSteps: 9,
  steps: [
    "ApplyDiscord",
    "ApplyFirstName",
    "ApplyDiscordEmail",
    "ApplyCountry",
    "ApplyServers",
    "ApplyPlatform",
    "ApplyAbout",
    "ApplyRank",
    // "ApplySubmitted",
  ],
  servers: [
    { id: 0, title: "Europe West" },
    { id: 1, title: "Europe Nordic East" },
    { id: 2, title: "North America" },
    { id: 3, title: "Oceania" },
    { id: 4, title: "Latin America North" },
    { id: 5, title: "Latin America South" },
    { id: 6, title: "Brazil" },
    { id: 7, title: "China" },
    { id: 8, title: "Japan" },
    { id: 9, title: "Korea" },
    { id: 10, title: "Other" },
  ],
  ranks: [
    {
      id: 50,
      title: "Diamond 30,000+",
    },
    {
      id: 500,
      title: "Diamond 50,000+",
    },
  ],
};
const cs2Step = {
  totalSteps: 8,
  steps: [
    "ApplyDiscord",
    "ApplyFirstName",
    "ApplyDiscordEmail",
    "ApplyCountry",
    "ApplyServers",
    "ApplyAbout",
    "ApplyRank",
    // "ApplySubmitted",
  ],
  servers: [
    { id: 0, title: "Europe West" },
    { id: 1, title: "Europe Nordic East" },
    { id: 2, title: "North America" },
    { id: 3, title: "Oceania" },
    { id: 4, title: "Latin America North" },
    { id: 5, title: "Latin America South" },
    { id: 6, title: "Brazil" },
    { id: 7, title: "China" },
    { id: 8, title: "Japan" },
    { id: 9, title: "Korea" },
    { id: 10, title: "Other" },
  ],
  ranks: [
    {
      id: 400,
      title: "Faceit 2000+",
    },
    {
      id: 300,
      title: "Faceit 2500+",
    },
  ],
};
const dota2Step = {
  totalSteps: 8,
  steps: [
    "ApplyDiscord",
    "ApplyFirstName",
    "ApplyDiscordEmail",
    "ApplyCountry",
    "ApplyServers",
    "ApplyAbout",
    "ApplyRank",
    // "ApplySubmitted",
  ],
  servers: [
    { id: 0, title: "Europe West" },
    { id: 1, title: "Europe Nordic East" },
    { id: 2, title: "North America" },
    { id: 3, title: "Oceania" },
    { id: 4, title: "Latin America North" },
    { id: 5, title: "Latin America South" },
    { id: 6, title: "Brazil" },
    { id: 7, title: "China" },
    { id: 8, title: "Japan" },
    { id: 9, title: "Korea" },
    { id: 10, title: "Other" },
  ],
  ranks: [
    {
      id: 17,
      title: "Divine 5000+ MMR",
    },
    {
      id: 18,
      title: "Immortal",
    },
  ],
};
const valorantStep = {
  totalSteps: 8,
  steps: [
    "ApplyDiscord",
    "ApplyFirstName",
    "ApplyDiscordEmail",
    "ApplyCountry",
    "ApplyServers",
    "ApplyAbout",
    "ApplyRank",
    // "ApplySubmitted",
  ],
  servers: [
    { id: 0, title: "Europe West" },
    { id: 1, title: "Europe Nordic East" },
    { id: 2, title: "North America" },
    { id: 3, title: "Oceania" },
    { id: 4, title: "Latin America North" },
    { id: 5, title: "Latin America South" },
    { id: 6, title: "Brazil" },
    { id: 7, title: "China" },
    { id: 8, title: "Japan" },
    { id: 9, title: "Korea" },
    { id: 10, title: "Other" },
  ],
  ranks: [
    {
      id: 17,
      title: "Immortal 250+",
    },
    {
      id: 18,
      title: "Immortal 500+",
    },
    {
      id: 19,
      title: "Radiant",
    },
  ],
};
const tftStep = {
  totalSteps: 8,
  steps: [
    "ApplyDiscord",
    "ApplyFirstName",
    "ApplyDiscordEmail",
    "ApplyCountry",
    "ApplyServers",
    "ApplyAbout",
    "ApplyRank",
    // "ApplySubmitted",
  ],
  servers: [
    { id: 0, title: "Europe West" },
    { id: 1, title: "Europe Nordic East" },
    { id: 2, title: "North America" },
    { id: 3, title: "Oceania" },
    { id: 4, title: "Latin America North" },
    { id: 5, title: "Latin America South" },
    { id: 6, title: "Brazil" },
    { id: 7, title: "China" },
    { id: 8, title: "Japan" },
    { id: 9, title: "Korea" },
    { id: 10, title: "Other" },
  ],
  ranks: [
    {
      id: 17,
      title: "Master",
    },
    {
      id: 18,
      title: "Grand Master",
    },
    {
      id: 19,
      title: "Challenger",
    },
  ],
};
const fortniteStep = {
  totalSteps: 9,
  steps: [
    "ApplyDiscord",
    "ApplyFirstName",
    "ApplyDiscordEmail",
    "ApplyCountry",
    "ApplyServers",
    "ApplyPlatform",
    "ApplyAbout",
    "ApplyRank",
    // "ApplySubmitted",
  ],
  servers: [
    { id: 0, title: "Europe West" },
    { id: 1, title: "Europe Nordic East" },
    { id: 2, title: "North America" },
    { id: 3, title: "Oceania" },
    { id: 4, title: "Latin America North" },
    { id: 5, title: "Latin America South" },
    { id: 6, title: "Brazil" },
    { id: 7, title: "China" },
    { id: 8, title: "Japan" },
    { id: 9, title: "Korea" },
    { id: 10, title: "Other" },
  ],
  ranks: [
    {
      id: 17,
      title: "Champion",
    },
    {
      id: 18,
      title: "Unreal",
    },
  ],
};

const marvelRivalsSteps = {
  totalSteps: 10,
  steps: [
    "ApplyDiscord",
    "ApplyFirstName",
    "ApplyDiscordEmail",
    "ApplyCountry",
    "ApplyServers",
    "ApplyPlatform",
    "ApplyAbout",
    "ApplyRank",
    "ApplyRoles",
  ],
  servers: [
    { id: 0, title: "North America" },
    { id: 1, title: "Europe" },
    { id: 2, title: "Middle East" },
    { id: 3, title: "South America" },
    { id: 4, title: "Asia-Pacific" },
  ],
  ranks: [],
};
const callofdutysteps = {
  totalSteps: 6,
  steps: [
    "ApplyDiscord",
    "ApplyFirstName",
    "ApplyDiscordEmail",
    "ApplyCountry",
    "ApplyAbout",
  ],
};
const fc25Steps = {
  totalSteps: 8,
  steps: [
    "ApplyDiscord",
    "ApplyFirstName",
    "ApplyDiscordEmail",
    "ApplyCountry",
    "ApplyAbout",
    "ApplyRank",
    "ApplyPlatform",
  ],
};
const countries = {
  afghanistan: "Afghanistan",
  "aland-islands": "Åland Islands",
  albania: "Albania",
  algeria: "Algeria",
  "american-samoa": "American Samoa",
  andorra: "AndorrA",
  angola: "Angola",
  anguilla: "Anguilla",
  antarctica: "Antarctica",
  "antigua-and-barbuda": "Antigua and Barbuda",
  argentina: "Argentina",
  armenia: "Armenia",
  aruba: "Aruba",
  australia: "Australia",
  austria: "Austria",
  azerbaijan: "Azerbaijan",
  bahamas: "Bahamas",
  bahrain: "Bahrain",
  bangladesh: "Bangladesh",
  barbados: "Barbados",
  belarus: "Belarus",
  belgium: "Belgium",
  belize: "Belize",
  benin: "Benin",
  bermuda: "Bermuda",
  bhutan: "Bhutan",
  bolivia: "Bolivia",
  "bosnia-and-herzegovina": "Bosnia and Herzegovina",
  botswana: "Botswana",
  "bouvet-island": "Bouvet Island",
  brazil: "Brazil",
  "british-indian-ocean-territory": "British Indian Ocean Territory",
  "brunei-darussalam": "Brunei Darussalam",
  bulgaria: "Bulgaria",
  "burkina-faso": "Burkina Faso",
  burundi: "Burundi",
  cambodia: "Cambodia",
  cameroon: "Cameroon",
  canada: "Canada",
  "cape-verde": "Cape Verde",
  "cayman-islands": "Cayman Islands",
  "central-african-republic": "Central African Republic",
  chad: "Chad",
  chile: "Chile",
  china: "China",
  "christmas-island": "Christmas Island",
  "cocos-(keeling)-islands": "Cocos (Keeling) Islands",
  colombia: "Colombia",
  comoros: "Comoros",
  congo: "Congo",
  "congo,-the-democratic-republic-of-the":
    "Congo, The Democratic Republic of the",
  "cook-islands": "Cook Islands",
  "costa-rica": "Costa Rica",
  "cote-d'ivoire": "Cote D'Ivoire",
  croatia: "Croatia",
  cuba: "Cuba",
  cyprus: "Cyprus",
  "czech-republic": "Czech Republic",
  denmark: "Denmark",
  djibouti: "Djibouti",
  dominica: "Dominica",
  "dominican-republic": "Dominican Republic",
  ecuador: "Ecuador",
  egypt: "Egypt",
  "el-salvador": "El Salvador",
  "equatorial-guinea": "Equatorial Guinea",
  eritrea: "Eritrea",
  estonia: "Estonia",
  ethiopia: "Ethiopia",
  "falkland-islands-(malvinas)": "Falkland Islands (Malvinas)",
  "faroe-islands": "Faroe Islands",
  fiji: "Fiji",
  finland: "Finland",
  france: "France",
  "french-guiana": "French Guiana",
  "french-polynesia": "French Polynesia",
  "french-southern-territories": "French Southern Territories",
  gabon: "Gabon",
  gambia: "Gambia",
  georgia: "Georgia",
  germany: "Germany",
  ghana: "Ghana",
  gibraltar: "Gibraltar",
  greece: "Greece",
  greenland: "Greenland",
  grenada: "Grenada",
  guadeloupe: "Guadeloupe",
  guam: "Guam",
  guatemala: "Guatemala",
  guernsey: "Guernsey",
  guinea: "Guinea",
  "guinea-bissau": "Guinea-Bissau",
  guyana: "Guyana",
  haiti: "Haiti",
  "heard-island-and-mcdonald-islands": "Heard Island and Mcdonald Islands",
  "holy-see-(vatican-city-state)": "Holy See (Vatican City State)",
  honduras: "Honduras",
  "hong-kong": "Hong Kong",
  hungary: "Hungary",
  iceland: "Iceland",
  india: "India",
  indonesia: "Indonesia",
  "iran,-islamic-republic-of": "Iran, Islamic Republic Of",
  iraq: "Iraq",
  ireland: "Ireland",
  "isle-of-man": "Isle of Man",
  israel: "Israel",
  italy: "Italy",
  jamaica: "Jamaica",
  japan: "Japan",
  jersey: "Jersey",
  jordan: "Jordan",
  kazakhstan: "Kazakhstan",
  kenya: "Kenya",
  kiribati: "Kiribati",
  "korea,-democratic-people's-republic-of":
    "Korea, Democratic People'S Republic of",
  "korea,-republic-of": "Korea, Republic of",
  kuwait: "Kuwait",
  kyrgyzstan: "Kyrgyzstan",
  "lao-people's-democratic-republic": "Lao People'S Democratic Republic",
  latvia: "Latvia",
  lebanon: "Lebanon",
  lesotho: "Lesotho",
  liberia: "Liberia",
  "libyan-arab-jamahiriya": "Libyan Arab Jamahiriya",
  liechtenstein: "Liechtenstein",
  lithuania: "Lithuania",
  luxembourg: "Luxembourg",
  macao: "Macao",
  "macedonia,-the-former-yugoslav-republic-of":
    "Macedonia, The Former Yugoslav Republic of",
  madagascar: "Madagascar",
  malawi: "Malawi",
  malaysia: "Malaysia",
  maldives: "Maldives",
  mali: "Mali",
  malta: "Malta",
  "marshall-islands": "Marshall Islands",
  martinique: "Martinique",
  mauritania: "Mauritania",
  mauritius: "Mauritius",
  mayotte: "Mayotte",
  mexico: "Mexico",
  "micronesia,-federated-states-of": "Micronesia, Federated States of",
  "moldova,-republic-of": "Moldova, Republic of",
  monaco: "Monaco",
  mongolia: "Mongolia",
  montserrat: "Montserrat",
  morocco: "Morocco",
  mozambique: "Mozambique",
  myanmar: "Myanmar",
  namibia: "Namibia",
  nauru: "Nauru",
  nepal: "Nepal",
  netherlands: "Netherlands",
  "netherlands-antilles": "Netherlands Antilles",
  "new-caledonia": "New Caledonia",
  "new-zealand": "New Zealand",
  nicaragua: "Nicaragua",
  niger: "Niger",
  nigeria: "Nigeria",
  niue: "Niue",
  "norfolk-island": "Norfolk Island",
  "northern-mariana-islands": "Northern Mariana Islands",
  norway: "Norway",
  oman: "Oman",
  pakistan: "Pakistan",
  palestine: "Palestine",
  palau: "Palau",
  "palestinian-territory,-occupied": "Palestinian Territory, Occupied",
  panama: "Panama",
  "papua-new-guinea": "Papua New Guinea",
  paraguay: "Paraguay",
  peru: "Peru",
  philippines: "Philippines",
  pitcairn: "Pitcairn",
  poland: "Poland",
  portugal: "Portugal",
  "puerto-rico": "Puerto Rico",
  qatar: "Qatar",
  reunion: "Reunion",
  romania: "Romania",
  "russian-federation": "Russian Federation",
  rwanda: "RWANDA",
  "saint-helena": "Saint Helena",
  "saint-kitts-and-nevis": "Saint Kitts and Nevis",
  "saint-lucia": "Saint Lucia",
  "saint-pierre-and-miquelon": "Saint Pierre and Miquelon",
  "saint-vincent-and-the-grenadines": "Saint Vincent and the Grenadines",
  samoa: "Samoa",
  "san-marino": "San Marino",
  "sao-tome-and-principe": "Sao Tome and Principe",
  "saudi-arabia": "Saudi Arabia",
  senegal: "Senegal",
  "serbia-and-montenegro": "Serbia and Montenegro",
  seychelles: "Seychelles",
  "sierra-leone": "Sierra Leone",
  singapore: "Singapore",
  slovakia: "Slovakia",
  slovenia: "Slovenia",
  "solomon-islands": "Solomon Islands",
  somalia: "Somalia",
  "south-africa": "South Africa",
  "south-georgia-and-the-south-sandwich-islands":
    "South Georgia and the South Sandwich Islands",
  spain: "Spain",
  "sri-lanka": "Sri Lanka",
  sudan: "Sudan",
  suriname: "Suriname",
  "svalbard-and-jan-mayen": "Svalbard and Jan Mayen",
  swaziland: "Swaziland",
  sweden: "Sweden",
  switzerland: "Switzerland",
  "syrian-arab-republic": "Syrian Arab Republic",
  "taiwan,-province-of-china": "Taiwan, Province of China",
  tajikistan: "Tajikistan",
  "tanzania,-united-republic-of": "Tanzania, United Republic of",
  thailand: "Thailand",
  "timor-leste": "Timor-Leste",
  togo: "Togo",
  tokelau: "Tokelau",
  tonga: "Tonga",
  "trinidad-and-tobago": "Trinidad and Tobago",
  tunisia: "Tunisia",
  turkey: "Turkey",
  turkmenistan: "Turkmenistan",
  "turks-and-caicos-islands": "Turks and Caicos Islands",
  tuvalu: "Tuvalu",
  uganda: "Uganda",
  ukraine: "Ukraine",
  "united-arab-emirates": "United Arab Emirates",
  "united-kingdom": "United Kingdom",
  "united-states": "United States",
  "united-states-minor-outlying-islands":
    "United States Minor Outlying Islands",
  uruguay: "Uruguay",
  uzbekistan: "Uzbekistan",
  vanuatu: "Vanuatu",
  venezuela: "Venezuela",
  "viet-nam": "Viet Nam",
  "virgin-islands,-british": "Virgin Islands, British",
  "virgin-islands,-u.s.": "Virgin Islands, U.S.",
  "wallis-and-futuna": "Wallis and Futuna",
  "western-sahara": "Western Sahara",
  yemen: "Yemen",
  zambia: "Zambia",
  zimbabwe: "Zimbabwe",
};

const countriesInArray = [
  {
    title: "Afghanistan",
    key: "Afghanistan",
    slug: "afghanistan",
  },
  {
    title: "Åland Islands",
    key: "Åland Islands",
    slug: "åland-islands",
  },
  {
    title: "Albania",
    key: "Albania",
    slug: "albania",
  },
  {
    title: "Algeria",
    key: "Algeria",
    slug: "algeria",
  },
  {
    title: "American Samoa",
    key: "American Samoa",
    slug: "american-samoa",
  },
  {
    title: "AndorrA",
    key: "AndorrA",
    slug: "andorra",
  },
  {
    title: "Angola",
    key: "Angola",
    slug: "angola",
  },
  {
    title: "Anguilla",
    key: "Anguilla",
    slug: "anguilla",
  },
  {
    title: "Antarctica",
    key: "Antarctica",
    slug: "antarctica",
  },
  {
    title: "Antigua and Barbuda",
    key: "Antigua and Barbuda",
    slug: "antigua-and-barbuda",
  },
  {
    title: "Argentina",
    key: "Argentina",
    slug: "argentina",
  },
  {
    title: "Armenia",
    key: "Armenia",
    slug: "armenia",
  },
  {
    title: "Aruba",
    key: "Aruba",
    slug: "aruba",
  },
  {
    title: "Australia",
    key: "Australia",
    slug: "australia",
  },
  {
    title: "Austria",
    key: "Austria",
    slug: "austria",
  },
  {
    title: "Azerbaijan",
    key: "Azerbaijan",
    slug: "azerbaijan",
  },
  {
    title: "Bahamas",
    key: "Bahamas",
    slug: "bahamas",
  },
  {
    title: "Bahrain",
    key: "Bahrain",
    slug: "bahrain",
  },
  {
    title: "Bangladesh",
    key: "Bangladesh",
    slug: "bangladesh",
  },
  {
    title: "Barbados",
    key: "Barbados",
    slug: "barbados",
  },
  {
    title: "Belarus",
    key: "Belarus",
    slug: "belarus",
  },
  {
    title: "Belgium",
    key: "Belgium",
    slug: "belgium",
  },
  {
    title: "Belize",
    key: "Belize",
    slug: "belize",
  },
  {
    title: "Benin",
    key: "Benin",
    slug: "benin",
  },
  {
    title: "Bermuda",
    key: "Bermuda",
    slug: "bermuda",
  },
  {
    title: "Bhutan",
    key: "Bhutan",
    slug: "bhutan",
  },
  {
    title: "Bolivia",
    key: "Bolivia",
    slug: "bolivia",
  },
  {
    title: "Bosnia and Herzegovina",
    key: "Bosnia and Herzegovina",
    slug: "bosnia-and-herzegovina",
  },
  {
    title: "Botswana",
    key: "Botswana",
    slug: "botswana",
  },
  {
    title: "Bouvet Island",
    key: "Bouvet Island",
    slug: "bouvet-island",
  },
  {
    title: "Brazil",
    key: "Brazil",
    slug: "brazil",
  },
  {
    title: "British Indian Ocean Territory",
    key: "British Indian Ocean Territory",
    slug: "british-indian-ocean-territory",
  },
  {
    title: "Brunei Darussalam",
    key: "Brunei Darussalam",
    slug: "brunei-darussalam",
  },
  {
    title: "Bulgaria",
    key: "Bulgaria",
    slug: "bulgaria",
  },
  {
    title: "Burkina Faso",
    key: "Burkina Faso",
    slug: "burkina-faso",
  },
  {
    title: "Burundi",
    key: "Burundi",
    slug: "burundi",
  },
  {
    title: "Cambodia",
    key: "Cambodia",
    slug: "cambodia",
  },
  {
    title: "Cameroon",
    key: "Cameroon",
    slug: "cameroon",
  },
  {
    title: "Canada",
    key: "Canada",
    slug: "canada",
  },
  {
    title: "Cape Verde",
    key: "Cape Verde",
    slug: "cape-verde",
  },
  {
    title: "Cayman Islands",
    key: "Cayman Islands",
    slug: "cayman-islands",
  },
  {
    title: "Central African Republic",
    key: "Central African Republic",
    slug: "central-african-republic",
  },
  {
    title: "Chad",
    key: "Chad",
    slug: "chad",
  },
  {
    title: "Chile",
    key: "Chile",
    slug: "chile",
  },
  {
    title: "China",
    key: "China",
    slug: "china",
  },
  {
    title: "Christmas Island",
    key: "Christmas Island",
    slug: "christmas-island",
  },
  {
    title: "Cocos (Keeling) Islands",
    key: "Cocos (Keeling) Islands",
    slug: "cocos-(keeling)-islands",
  },
  {
    title: "Colombia",
    key: "Colombia",
    slug: "colombia",
  },
  {
    title: "Comoros",
    key: "Comoros",
    slug: "comoros",
  },
  {
    title: "Congo",
    key: "Congo",
    slug: "congo",
  },
  {
    title: "Congo, The Democratic Republic of the",
    key: "Congo, The Democratic Republic of the",
    slug: "congo,-the-democratic-republic-of-the",
  },
  {
    title: "Cook Islands",
    key: "Cook Islands",
    slug: "cook-islands",
  },
  {
    title: "Costa Rica",
    key: "Costa Rica",
    slug: "costa-rica",
  },
  {
    title: "Cote D'Ivoire",
    key: "Cote D'Ivoire",
    slug: "cote-d'ivoire",
  },
  {
    title: "Croatia",
    key: "Croatia",
    slug: "croatia",
  },
  {
    title: "Cuba",
    key: "Cuba",
    slug: "cuba",
  },
  {
    title: "Cyprus",
    key: "Cyprus",
    slug: "cyprus",
  },
  {
    title: "Czech Republic",
    key: "Czech Republic",
    slug: "czech-republic",
  },
  {
    title: "Denmark",
    key: "Denmark",
    slug: "denmark",
  },
  {
    title: "Djibouti",
    key: "Djibouti",
    slug: "djibouti",
  },
  {
    title: "Dominica",
    key: "Dominica",
    slug: "dominica",
  },
  {
    title: "Dominican Republic",
    key: "Dominican Republic",
    slug: "dominican-republic",
  },
  {
    title: "Ecuador",
    key: "Ecuador",
    slug: "ecuador",
  },
  {
    title: "Egypt",
    key: "Egypt",
    slug: "egypt",
  },
  {
    title: "El Salvador",
    key: "El Salvador",
    slug: "el-salvador",
  },
  {
    title: "Equatorial Guinea",
    key: "Equatorial Guinea",
    slug: "equatorial-guinea",
  },
  {
    title: "Eritrea",
    key: "Eritrea",
    slug: "eritrea",
  },
  {
    title: "Estonia",
    key: "Estonia",
    slug: "estonia",
  },
  {
    title: "Ethiopia",
    key: "Ethiopia",
    slug: "ethiopia",
  },
  {
    title: "Falkland Islands (Malvinas)",
    key: "Falkland Islands (Malvinas)",
    slug: "falkland-islands-(malvinas)",
  },
  {
    title: "Faroe Islands",
    key: "Faroe Islands",
    slug: "faroe-islands",
  },
  {
    title: "Fiji",
    key: "Fiji",
    slug: "fiji",
  },
  {
    title: "Finland",
    key: "Finland",
    slug: "finland",
  },
  {
    title: "France",
    key: "France",
    slug: "france",
  },
  {
    title: "French Guiana",
    key: "French Guiana",
    slug: "french-guiana",
  },
  {
    title: "French Polynesia",
    key: "French Polynesia",
    slug: "french-polynesia",
  },
  {
    title: "French Southern Territories",
    key: "French Southern Territories",
    slug: "french-southern-territories",
  },
  {
    title: "Gabon",
    key: "Gabon",
    slug: "gabon",
  },
  {
    title: "Gambia",
    key: "Gambia",
    slug: "gambia",
  },
  {
    title: "Georgia",
    key: "Georgia",
    slug: "georgia",
  },
  {
    title: "Germany",
    key: "Germany",
    slug: "germany",
  },
  {
    title: "Ghana",
    key: "Ghana",
    slug: "ghana",
  },
  {
    title: "Gibraltar",
    key: "Gibraltar",
    slug: "gibraltar",
  },
  {
    title: "Greece",
    key: "Greece",
    slug: "greece",
  },
  {
    title: "Greenland",
    key: "Greenland",
    slug: "greenland",
  },
  {
    title: "Grenada",
    key: "Grenada",
    slug: "grenada",
  },
  {
    title: "Guadeloupe",
    key: "Guadeloupe",
    slug: "guadeloupe",
  },
  {
    title: "Guam",
    key: "Guam",
    slug: "guam",
  },
  {
    title: "Guatemala",
    key: "Guatemala",
    slug: "guatemala",
  },
  {
    title: "Guernsey",
    key: "Guernsey",
    slug: "guernsey",
  },
  {
    title: "Guinea",
    key: "Guinea",
    slug: "guinea",
  },
  {
    title: "Guinea-Bissau",
    key: "Guinea-Bissau",
    slug: "guinea-bissau",
  },
  {
    title: "Guyana",
    key: "Guyana",
    slug: "guyana",
  },
  {
    title: "Haiti",
    key: "Haiti",
    slug: "haiti",
  },
  {
    title: "Heard Island and Mcdonald Islands",
    key: "Heard Island and Mcdonald Islands",
    slug: "heard-island-and-mcdonald-islands",
  },
  {
    title: "Holy See (Vatican City State)",
    key: "Holy See (Vatican City State)",
    slug: "holy-see-(vatican-city-state)",
  },
  {
    title: "Honduras",
    key: "Honduras",
    slug: "honduras",
  },
  {
    title: "Hong Kong",
    key: "Hong Kong",
    slug: "hong-kong",
  },
  {
    title: "Hungary",
    key: "Hungary",
    slug: "hungary",
  },
  {
    title: "Iceland",
    key: "Iceland",
    slug: "iceland",
  },
  {
    title: "India",
    key: "India",
    slug: "india",
  },
  {
    title: "Indonesia",
    key: "Indonesia",
    slug: "indonesia",
  },
  {
    title: "Iran, Islamic Republic Of",
    key: "Iran, Islamic Republic Of",
    slug: "iran,-islamic-republic-of",
  },
  {
    title: "Iraq",
    key: "Iraq",
    slug: "iraq",
  },
  {
    title: "Ireland",
    key: "Ireland",
    slug: "ireland",
  },
  {
    title: "Isle of Man",
    key: "Isle of Man",
    slug: "isle-of-man",
  },
  {
    title: "Israel",
    key: "Israel",
    slug: "israel",
  },
  {
    title: "Italy",
    key: "Italy",
    slug: "italy",
  },
  {
    title: "Jamaica",
    key: "Jamaica",
    slug: "jamaica",
  },
  {
    title: "Japan",
    key: "Japan",
    slug: "japan",
  },
  {
    title: "Jersey",
    key: "Jersey",
    slug: "jersey",
  },
  {
    title: "Jordan",
    key: "Jordan",
    slug: "jordan",
  },
  {
    title: "Kazakhstan",
    key: "Kazakhstan",
    slug: "kazakhstan",
  },
  {
    title: "Kenya",
    key: "Kenya",
    slug: "kenya",
  },
  {
    title: "Kiribati",
    key: "Kiribati",
    slug: "kiribati",
  },
  {
    title: "Korea, Democratic People'S Republic of",
    key: "Korea, Democratic People'S Republic of",
    slug: "korea,-democratic-people's-republic-of",
  },
  {
    title: "Korea, Republic of",
    key: "Korea, Republic of",
    slug: "korea,-republic-of",
  },
  {
    title: "Kuwait",
    key: "Kuwait",
    slug: "kuwait",
  },
  {
    title: "Kyrgyzstan",
    key: "Kyrgyzstan",
    slug: "kyrgyzstan",
  },
  {
    title: "Lao People'S Democratic Republic",
    key: "Lao People'S Democratic Republic",
    slug: "lao-people's-democratic-republic",
  },
  {
    title: "Latvia",
    key: "Latvia",
    slug: "latvia",
  },
  {
    title: "Lebanon",
    key: "Lebanon",
    slug: "lebanon",
  },
  {
    title: "Lesotho",
    key: "Lesotho",
    slug: "lesotho",
  },
  {
    title: "Liberia",
    key: "Liberia",
    slug: "liberia",
  },
  {
    title: "Libyan Arab Jamahiriya",
    key: "Libyan Arab Jamahiriya",
    slug: "libyan-arab-jamahiriya",
  },
  {
    title: "Liechtenstein",
    key: "Liechtenstein",
    slug: "liechtenstein",
  },
  {
    title: "Lithuania",
    key: "Lithuania",
    slug: "lithuania",
  },
  {
    title: "Luxembourg",
    key: "Luxembourg",
    slug: "luxembourg",
  },
  {
    title: "Macao",
    key: "Macao",
    slug: "macao",
  },
  {
    title: "Macedonia, The Former Yugoslav Republic of",
    key: "Macedonia, The Former Yugoslav Republic of",
    slug: "macedonia,-the-former-yugoslav-republic-of",
  },
  {
    title: "Madagascar",
    key: "Madagascar",
    slug: "madagascar",
  },
  {
    title: "Malawi",
    key: "Malawi",
    slug: "malawi",
  },
  {
    title: "Malaysia",
    key: "Malaysia",
    slug: "malaysia",
  },
  {
    title: "Maldives",
    key: "Maldives",
    slug: "maldives",
  },
  {
    title: "Mali",
    key: "Mali",
    slug: "mali",
  },
  {
    title: "Malta",
    key: "Malta",
    slug: "malta",
  },
  {
    title: "Marshall Islands",
    key: "Marshall Islands",
    slug: "marshall-islands",
  },
  {
    title: "Martinique",
    key: "Martinique",
    slug: "martinique",
  },
  {
    title: "Mauritania",
    key: "Mauritania",
    slug: "mauritania",
  },
  {
    title: "Mauritius",
    key: "Mauritius",
    slug: "mauritius",
  },
  {
    title: "Mayotte",
    key: "Mayotte",
    slug: "mayotte",
  },
  {
    title: "Mexico",
    key: "Mexico",
    slug: "mexico",
  },
  {
    title: "Micronesia, Federated States of",
    key: "Micronesia, Federated States of",
    slug: "micronesia,-federated-states-of",
  },
  {
    title: "Moldova, Republic of",
    key: "Moldova, Republic of",
    slug: "moldova,-republic-of",
  },
  {
    title: "Monaco",
    key: "Monaco",
    slug: "monaco",
  },
  {
    title: "Mongolia",
    key: "Mongolia",
    slug: "mongolia",
  },
  {
    title: "Montserrat",
    key: "Montserrat",
    slug: "montserrat",
  },
  {
    title: "Morocco",
    key: "Morocco",
    slug: "morocco",
  },
  {
    title: "Mozambique",
    key: "Mozambique",
    slug: "mozambique",
  },
  {
    title: "Myanmar",
    key: "Myanmar",
    slug: "myanmar",
  },
  {
    title: "Namibia",
    key: "Namibia",
    slug: "namibia",
  },
  {
    title: "Nauru",
    key: "Nauru",
    slug: "nauru",
  },
  {
    title: "Nepal",
    key: "Nepal",
    slug: "nepal",
  },
  {
    title: "Netherlands",
    key: "Netherlands",
    slug: "netherlands",
  },
  {
    title: "Netherlands Antilles",
    key: "Netherlands Antilles",
    slug: "netherlands-antilles",
  },
  {
    title: "New Caledonia",
    key: "New Caledonia",
    slug: "new-caledonia",
  },
  {
    title: "New Zealand",
    key: "New Zealand",
    slug: "new-zealand",
  },
  {
    title: "Nicaragua",
    key: "Nicaragua",
    slug: "nicaragua",
  },
  {
    title: "Niger",
    key: "Niger",
    slug: "niger",
  },
  {
    title: "Nigeria",
    key: "Nigeria",
    slug: "nigeria",
  },
  {
    title: "Niue",
    key: "Niue",
    slug: "niue",
  },
  {
    title: "Norfolk Island",
    key: "Norfolk Island",
    slug: "norfolk-island",
  },
  {
    title: "Northern Mariana Islands",
    key: "Northern Mariana Islands",
    slug: "northern-mariana-islands",
  },
  {
    title: "Norway",
    key: "Norway",
    slug: "norway",
  },
  {
    title: "Oman",
    key: "Oman",
    slug: "oman",
  },
  {
    title: "Pakistan",
    key: "Pakistan",
    slug: "pakistan",
  },
  {
    title: "Palau",
    key: "Palau",
    slug: "palau",
  },
  {
    title: "Palestinian Territory, Occupied",
    key: "Palestinian Territory, Occupied",
    slug: "palestinian-territory,-occupied",
  },
  {
    title: "Panama",
    key: "Panama",
    slug: "panama",
  },
  {
    title: "Papua New Guinea",
    key: "Papua New Guinea",
    slug: "papua-new-guinea",
  },
  {
    title: "Paraguay",
    key: "Paraguay",
    slug: "paraguay",
  },
  {
    title: "Peru",
    key: "Peru",
    slug: "peru",
  },
  {
    title: "Philippines",
    key: "Philippines",
    slug: "philippines",
  },
  {
    title: "Pitcairn",
    key: "Pitcairn",
    slug: "pitcairn",
  },
  {
    title: "Poland",
    key: "Poland",
    slug: "poland",
  },
  {
    title: "Portugal",
    key: "Portugal",
    slug: "portugal",
  },
  {
    title: "Puerto Rico",
    key: "Puerto Rico",
    slug: "puerto-rico",
  },
  {
    title: "Qatar",
    key: "Qatar",
    slug: "qatar",
  },
  {
    title: "Reunion",
    key: "Reunion",
    slug: "reunion",
  },
  {
    title: "Romania",
    key: "Romania",
    slug: "romania",
  },
  {
    title: "Russian Federation",
    key: "Russian Federation",
    slug: "russian-federation",
  },
  {
    title: "RWANDA",
    key: "RWANDA",
    slug: "rwanda",
  },
  {
    title: "Saint Helena",
    key: "Saint Helena",
    slug: "saint-helena",
  },
  {
    title: "Saint Kitts and Nevis",
    key: "Saint Kitts and Nevis",
    slug: "saint-kitts-and-nevis",
  },
  {
    title: "Saint Lucia",
    key: "Saint Lucia",
    slug: "saint-lucia",
  },
  {
    title: "Saint Pierre and Miquelon",
    key: "Saint Pierre and Miquelon",
    slug: "saint-pierre-and-miquelon",
  },
  {
    title: "Saint Vincent and the Grenadines",
    key: "Saint Vincent and the Grenadines",
    slug: "saint-vincent-and-the-grenadines",
  },
  {
    title: "Samoa",
    key: "Samoa",
    slug: "samoa",
  },
  {
    title: "San Marino",
    key: "San Marino",
    slug: "san-marino",
  },
  {
    title: "Sao Tome and Principe",
    key: "Sao Tome and Principe",
    slug: "sao-tome-and-principe",
  },
  {
    title: "Saudi Arabia",
    key: "Saudi Arabia",
    slug: "saudi-arabia",
  },
  {
    title: "Senegal",
    key: "Senegal",
    slug: "senegal",
  },
  {
    title: "Serbia and Montenegro",
    key: "Serbia and Montenegro",
    slug: "serbia-and-montenegro",
  },
  {
    title: "Seychelles",
    key: "Seychelles",
    slug: "seychelles",
  },
  {
    title: "Sierra Leone",
    key: "Sierra Leone",
    slug: "sierra-leone",
  },
  {
    title: "Singapore",
    key: "Singapore",
    slug: "singapore",
  },
  {
    title: "Slovakia",
    key: "Slovakia",
    slug: "slovakia",
  },
  {
    title: "Slovenia",
    key: "Slovenia",
    slug: "slovenia",
  },
  {
    title: "Solomon Islands",
    key: "Solomon Islands",
    slug: "solomon-islands",
  },
  {
    title: "Somalia",
    key: "Somalia",
    slug: "somalia",
  },
  {
    title: "South Africa",
    key: "South Africa",
    slug: "south-africa",
  },
  {
    title: "South Georgia and the South Sandwich Islands",
    key: "South Georgia and the South Sandwich Islands",
    slug: "south-georgia-and-the-south-sandwich-islands",
  },
  {
    title: "Spain",
    key: "Spain",
    slug: "spain",
  },
  {
    title: "Sri Lanka",
    key: "Sri Lanka",
    slug: "sri-lanka",
  },
  {
    title: "Sudan",
    key: "Sudan",
    slug: "sudan",
  },
  {
    title: "Suriname",
    key: "Suriname",
    slug: "suriname",
  },
  {
    title: "Svalbard and Jan Mayen",
    key: "Svalbard and Jan Mayen",
    slug: "svalbard-and-jan-mayen",
  },
  {
    title: "Swaziland",
    key: "Swaziland",
    slug: "swaziland",
  },
  {
    title: "Sweden",
    key: "Sweden",
    slug: "sweden",
  },
  {
    title: "Switzerland",
    key: "Switzerland",
    slug: "switzerland",
  },
  {
    title: "Syrian Arab Republic",
    key: "Syrian Arab Republic",
    slug: "syrian-arab-republic",
  },
  {
    title: "Taiwan, Province of China",
    key: "Taiwan, Province of China",
    slug: "taiwan,-province-of-china",
  },
  {
    title: "Tajikistan",
    key: "Tajikistan",
    slug: "tajikistan",
  },
  {
    title: "Tanzania, United Republic of",
    key: "Tanzania, United Republic of",
    slug: "tanzania,-united-republic-of",
  },
  {
    title: "Thailand",
    key: "Thailand",
    slug: "thailand",
  },
  {
    title: "Timor-Leste",
    key: "Timor-Leste",
    slug: "timor-leste",
  },
  {
    title: "Togo",
    key: "Togo",
    slug: "togo",
  },
  {
    title: "Tokelau",
    key: "Tokelau",
    slug: "tokelau",
  },
  {
    title: "Tonga",
    key: "Tonga",
    slug: "tonga",
  },
  {
    title: "Trinidad and Tobago",
    key: "Trinidad and Tobago",
    slug: "trinidad-and-tobago",
  },
  {
    title: "Tunisia",
    key: "Tunisia",
    slug: "tunisia",
  },
  {
    title: "Turkey",
    key: "Turkey",
    slug: "turkey",
  },
  {
    title: "Turkmenistan",
    key: "Turkmenistan",
    slug: "turkmenistan",
  },
  {
    title: "Turks and Caicos Islands",
    key: "Turks and Caicos Islands",
    slug: "turks-and-caicos-islands",
  },
  {
    title: "Tuvalu",
    key: "Tuvalu",
    slug: "tuvalu",
  },
  {
    title: "Uganda",
    key: "Uganda",
    slug: "uganda",
  },
  {
    title: "Ukraine",
    key: "Ukraine",
    slug: "ukraine",
  },
  {
    title: "United Arab Emirates",
    key: "United Arab Emirates",
    slug: "united-arab-emirates",
  },
  {
    title: "United Kingdom",
    key: "United Kingdom",
    slug: "united-kingdom",
  },
  {
    title: "United States",
    key: "United States",
    slug: "united-states",
  },
  {
    title: "United States Minor Outlying Islands",
    key: "United States Minor Outlying Islands",
    slug: "united-states-minor-outlying-islands",
  },
  {
    title: "Uruguay",
    key: "Uruguay",
    slug: "uruguay",
  },
  {
    title: "Uzbekistan",
    key: "Uzbekistan",
    slug: "uzbekistan",
  },
  {
    title: "Vanuatu",
    key: "Vanuatu",
    slug: "vanuatu",
  },
  {
    title: "Venezuela",
    key: "Venezuela",
    slug: "venezuela",
  },
  {
    title: "Viet Nam",
    key: "Viet Nam",
    slug: "viet-nam",
  },
  {
    title: "Virgin Islands, British",
    key: "Virgin Islands, British",
    slug: "virgin-islands,-british",
  },
  {
    title: "Virgin Islands, U.S.",
    key: "Virgin Islands, U.S.",
    slug: "virgin-islands,-u.s.",
  },
  {
    title: "Wallis and Futuna",
    key: "Wallis and Futuna",
    slug: "wallis-and-futuna",
  },
  {
    title: "Western Sahara",
    key: "Western Sahara",
    slug: "western-sahara",
  },
  {
    title: "Yemen",
    key: "Yemen",
    slug: "yemen",
  },
  {
    title: "Zambia",
    key: "Zambia",
    slug: "zambia",
  },
  {
    title: "Zimbabwe",
    key: "Zimbabwe",
    slug: "zimbabwe",
  },
];

const wowSteps = {
  totalSteps: 9,
  steps: [
    "ApplyFirstName",
    "ApplyDiscordEmail",
    "ApplyCountry",
    "ApplyServers",
    "ApplyRealms",
    "ApplyApplication",
    "ApplyLeader",
    "ApplyAbout",
    // "ApplySubmitted",
  ],
  servers: [
    { id: 0, title: "Europe" },
    { id: 1, title: "US" },
  ],
};

const loadConfig = (slug) => {
  if (slug === "rocket-league-boost") {
    return rocketLeagueSteps;
  } else if (slug === "league-of-legends-boost") {
    return LeagueOfLegendsSteps;
  } else if (slug === "apex-legends-boost") {
    return apexLegendsStep;
  } else if (slug === "rainbow-six-siege-boost") {
    return rainbowSixStep;
  } else if (slug === "ow-boost") {
    return overwatch2Step;
  } else if (slug === "valorant-boost") {
    return valorantStep;
  } else if (slug === "counter-strike-2-boost") {
    return cs2Step;
  } else if (slug === "dota-2-boost") {
    return dota2Step;
  } else if (slug === "fortnite-boost") {
    return fortniteStep;
  } else if (slug === "teamfight-tactics-boost") {
    return tftStep;
  } else if (slug === "the-finals-boost") {
    return theFinalsStep;
  } else if (slug === "world-of-warcraft-boost") {
    return wowSteps;
  } else if (slug === "marvel-rivals-boost") {
    return marvelRivalsSteps;
  } else if (slug === "call-of-duty-boost") {
    return callofdutysteps;
  } else if (slug === "fc-boost") {
    return fc25Steps;
  }
  return {};
};
export { loadConfig, countries, countriesInArray };
